export default [{
  header: 'Organization',
},
{
  title: 'Complaint Channel',
  icon: 'ExternalLinkIcon',
  route: 'organization-complaint-list',
  children: [
    {
      title: 'New/State',
      route: 'complaint-follow-up',
      target: "_blank",
      // Ruta pública sin sesión (pages.js, en pagesUserNotLogged) — este moduleKey es
      // puramente de visibilidad del link en el menú, no protege la ruta en sí (agregarle
      // meta.module a la ruta bloquearía solo al personal logueado, no a nadie externo con
      // el link directo). Decisión explícita: separado de 'complaint-channel' para que
      // verlo no dependa de tener acceso a la lista interna.
      moduleKey: 'complaint-follow-up',
    },
    {
      title: 'List',
      route: 'organization-complaint-list',
      moduleKey: 'complaint-channel',
    },
  ],
},
// {
//   title: 'Due Diligence',
//   route: 'misc-coming-soon',
//   icon: 'SearchIcon',
// },
// {
//   title: 'Conflict of Interests',
//   route: 'misc-coming-soon',
//   icon: 'UploadIcon',
// },
{
  title: 'Records',
  icon: 'FolderPlusIcon',
  route: 'organization-library-list',
  children: [
    {
      title: 'Library',
      route: 'organization-library-list',
      moduleKey: 'records-library',
    },
    {
      title: 'Confl. of Interest Collaborator',
      tooltip: 'Conflict of Interest Collaborator',
      route: 'organization-conflict-of-interest-collaborator-list',
      moduleKey: 'records-coi-collaborator',
    },
    {
      title: 'Confl. of Interest Supplier',
      tooltip: 'Conflict of Interest Supplier',
      route: 'organization-conflict-of-interest-supplier-list',
      moduleKey: 'records-coi-supplier',
    },
    {
      title: 'Terceros - Relacionamiento',
      route: 'organization-lobby-list',
      moduleKey: 'records-lobby',
    },
  ],
},
{
  title: 'Organization_',
  icon: 'UsersIcon',
  route: 'organization-worker-list',
  children: [
    {
      title: 'Users',
      route: 'organization-worker-list',
      moduleKey: 'organization-workers',
    },
    {
      title: 'Locations',
      route: 'organization-location-list',
      moduleKey: 'organization-locations',
    },
    {
      title: 'Roles',
      route: 'organization-role-list',
      moduleKey: 'organization-roles',
    },
    {
      title: 'Companies',
      route: 'organization-company-list',
      moduleKey: 'organization-companies',
    },
    {
      title: 'IDs',
      route: 'organization-id-list',
      moduleKey: 'organization-ids',
    },
  ],
},
{
  title: 'Crimes',
  icon: 'DatabaseIcon',
  route: 'organization-crime-list',
  moduleKey: 'crimes',
},
  /* {
  title: 'Employees',
  icon: 'FilmIcon',
  children: [{
    title: 'Users',
    route: 'organization-worker-list',
  },
  {
    title: 'Roles',
    route: 'organization-role-list',
  },
  {
    title: 'Locations',
    route: 'organization-location-list',
  },
  {
    title: 'Metadata',
    route: 'organization-metadata-list',
  },
  ],
}, */
/* {
    title: 'Confirmation Planning',
    icon: 'ClipboardIcon',
    route: 'organization-confirmation-planning-list',
  } */
]
